import { useEffect, useState } from "react";
import classNames from "classnames";

// Components
import Loader from "components/atoms/Loader";
import BangerLogoAnimate from "components/atoms/BangerLogoAnimate";

// Images
import Logo from "assets/icons/glory/logo_big.svg?react";

import "./styles.sass";

type PreloaderProps = {
  progress: number;
  closeTime: number;
};

let timeout: NodeJS.Timeout | null = null;

const Preloader = (props: PreloaderProps) => {
  const { progress, closeTime } = props;

  const [shouldRender, setShouldRender] = useState(true);
  const [isTimeToClose, setIsTimeToClose] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsTimeToClose(true);
    }, closeTime);
  }, [closeTime]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (progress >= 100) {
      setTimeout(() => {
        setIsTimeToClose(true);
      }, 550);

      timeout = setTimeout(() => setShouldRender(false), 3500);
      return () => {
        // eslint-disable-next-line no-unused-expressions
        timeout && clearTimeout(timeout);
      };
    }
  }, [progress]);

  if (!shouldRender) {
    return null;
  }

  const preloaderClass = classNames("Preloader", {
    hide: isTimeToClose && progress >= 100,
    banger: import.meta.env.VITE_APP_PROJECT_NAME === "banger",
  });

  const preloaderCenterClass = classNames("Preloader__center");

  if (import.meta.env.VITE_APP_PROJECT_NAME === "banger") {
    return (
      <div className={preloaderClass}>
        <div className={preloaderCenterClass}>
          <BangerLogoAnimate />
        </div>
      </div>
    );
  }

  return (
    <div className={preloaderClass}>
      <div className="Preloader__center">
        <Logo className="Preloader__logo" />
        <Loader width={progress} />
      </div>
    </div>
  );
};

export default Preloader;
